import React from 'react'
import '../components-css/sitemap.scss'
import { Link } from "react-router-dom";
const Sitemap = () => {
    return (
        <div className="sitemap-main-container">
            <div className="sitemap-container">
            <h1>Easily Find What You’re Looking For</h1>
            <div className="sitemap-section">
                <div className="home">
                    <span>QUICK LINKS</span>
                    <Link to="/">HOME</Link>
                    <Link to="/about-us">ABOUT</Link>
                    <Link to="/career">Career</Link>
                    <Link to="/our-clients">Our Clients</Link>
                    <Link to="/our-testimonials">Our Testimonials</Link>
                    <Link to="/hire-resources">Hire Resources</Link>
                    <Link to="/portfolio">Portfolio</Link>
                    <Link to="/case-study">Case study</Link>
                    <Link to="/blogs">BLOG</Link>
                    <Link to="/contact-us">CONTACT</Link>
                </div>
                {/* <div className="industries">
                    <Link>INDUSTRIES</Link>
                    <Link to="/contact-us">Ecommerce App</Link>
                    <Link>Social Media App</Link>
                    <Link>Magazine & Newspaper App</Link>
                    <Link>Fitness</Link>
                    <Link>Logistics</Link>
                    <Link>Aviation</Link>
                    <Link>Agriculture</Link>
                </div> */}
                <div className="services">
                    <span>SERVICES</span>
                    <Link to="/services/branding-designing">Branding and designing</Link>
                    <Link to="/services/web-design-development">Web design and development</Link>
                    <Link to="/services/mobile-app-development">Mobile app development</Link>
                    <Link to="/services/enterprise-software-development">Enterprise software development</Link>
                    <Link to="/services/business-consultation">Business consultation</Link>
                    <Link to="/services/digital-marketing">Digital marketing</Link>
                    <Link to="/services/it-managed-services">IT managed services</Link>
                </div>
                <div className="resources">
                    <span>RESOURCES</span>
                    <Link to="/blogs">BLOGS</Link>
                </div>
                <div className="countries-we-serve">
                    <span>LOCATIONS WE SERVE</span>
                    <a href="https://omkatech.com/location/">SEO Services in Delhi NCR</a>
                    <a href="https://omkatech.com/location/expert-seo-services-company-in-the-usa/">SEO Services in USA</a>
                    <a href="https://omkatech.com/location/seo-company-in-canada/">SEO Services in Canada</a>
                    <a href="https://omkatech.com/location/seo-company-in-germany/">SEO Services in Germany</a>
                    <a href="https://omkatech.com/location/seo-company-in-the-uk/">SEO Services in UK</a>
                    <a href="https://omkatech.com/location/seo-company-in-texas/">SEO Services in Texas</a>
                    <a href="https://omkatech.com/location/seo-company-los-angeles/">SEO Services in Los Angeles</a>
                    <a href="https://omkatech.com/location/professional-seo-services-california/">SEO Services in California</a>
                </div>
            </div>
            </div>
        </div>
    )
}
export default Sitemap